import { makeStyles } from '@mui/styles';
const maxWidth = '120px !important';
const minWidth = '120px !important';
const fontSize = '11px !important';
const padding = '8px';
const height = '30px';
export const useStyles = makeStyles((theme) => ({
  red: {
    color: 'red',
    backgroundColor: 'red',
    color: 'white',
    borderRadius: '50%',
  },
  green: {
    color: 'green',
    backgroundColor: 'green',
    color: 'white',
    borderRadius: '50%',
  },
  headerTime: {
    backgroundColor: '#2b3990',
    border: '1px solid #fff',
    padding: '4px',
    textAlign: 'center',
    padding: '8px 0',
    color: 'white',
  },
  customStyle: {
    borderRadius: '8px !important',

    backgroundImage: 'linear-gradient(to right, white, blue)',

    boxShadow:
      'rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px',
  },
  customStyle2: {
    borderRadius: '8px !important',
    backgroundColor: '#9fd892',
    backgroundImage: 'linear-gradient(90deg, #9fd892 0%, #cdf1dd 100%)',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle3: {
    borderRadius: '8px !important',
    backgroundColor: '#85FFBD',
    backgroundImage: 'linear-gradient(45deg, #85FFBD 0%, #FFFB7D 100%)',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle4: {
    borderRadius: '8px !important',
    backgroundColor: '#f5f5f5',
    backgroundImage: 'linear-gradient(45deg, #f5f5f5 0%, #2c8fd8 100%)',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle5: {
    borderRadius: '8px !important',
    backgroundColor: '#FFDEE9',
    backgroundImage: 'linear-gradient(0deg, #FFDEE9 0%, #B5FFFC 100%)',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle6: {
    borderRadius: '8px !important',
    backgroundImage:
      'radial-gradient( circle farthest-corner at 92.3% 71.5%,  rgba(83,138,214,1) 0%, rgba(134,231,214,1) 90% )',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle7: {
    borderRadius: '8px !important',
    backgroundImage:
      'radial-gradient( circle farthest-corner at 10% 20%,  rgba(97,186,255,1) 0%, rgba(166,239,253,1) 90.1% );',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle8: {
    borderRadius: '8px !important',
    background: '#7F7FD5' /* fallback for old browsers */,
    background: '-webkit-linear-gradient(to right, #91EAE4, #86A8E7, #7F7FD5)',
    background: 'linear-gradient(to right, #91EAE4, #86A8E7, #7F7FD5)',
    boxShadow: '-8px 2px 5px rgba(136, 165, 191, 0.48);',
  },
  customStyle9: {
    borderRadius: '8px !important',
    backgroundColor: '#fff8db',
    backgroundImage: 'linear-gradient(62deg, #fff8db 0%, #f58445 100%)',
  },
  chartItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: fontSize,
    height: height,
    maxWidth: maxWidth,
    minWidth: minWidth,
    padding: padding,
    margin: '2px',
    direction:'ltr',
    cursor:'default',
    borderRadius:'4px'
  },
  customStyleGreen: {
    //borderRadius: '8px !important',
    backgroundColor: '#547c00',
    backgroundImage: 'linear-gradient(0deg, #547c00 0%, #85d479 100%)',
    color: 'white',
  },
  customStyleBlue: {
    //borderRadius: '8px !important',
    backgroundColor: '#1ba4dc',
    backgroundImage: 'linear-gradient(0deg, #1ba4dc 0%, #56c8f7 100%)',
    color: 'white',
  },
  customStyleWhite: {
    //borderRadius: '8px !important',
    backgroundColor: '#dcdcdc',
    backgroundImage: 'linear-gradient(0deg, #dcdcdc 0%, #f3ecec  100%)',
  },
  customStyleRed: {
    color: 'white',
    //borderRadius: '8px !important',
    backgroundColor: '#a61b0e',
    backgroundImage: 'linear-gradient(0deg, #a61b0e 0%, #df2c1d 100%)',
    //border: '1px solid #a61b0e',
  },
  testMe: {
    backgroundColor: '#ccc',
    borderRadius: '8px',
    padding: '8px',
  },
  info: {
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
    marginBottom: theme.spacing(1),
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },

  mrRight: {
    marginLeft: '16px',
    fontSize: '11px',
    fontWeight: '500',
  },
  mappingItem: {
    width: '30px',
    height: '30px',
  },
  mappingBox: {
    display: 'flex',
    justifyContent: '',
    border: '1px solid #ccc',
    padding: '16px',
    marginBottom: '8px',
    marginTop: '8px',
  },
  mappingBoxItem: {
    display: 'flex',
    alignItems: 'center',
    //width: '12%',
    marginRight: '30px',
  },
  marginSpace: {
    margin: '2px 0 ',
  },
  dvDisable: {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    padding: '10px',
    textAlign: 'center',
    margin: '2px 0 ',
    color: 'rgba(0, 0, 0, 0.26)',
    fontSize: '12px',
    cursor: 'not-allowed',
    fontWeight: '500',
  },
  boxActions: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  btnActions: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      //width:'50%',
    },
    [theme.breakpoints.down('sm')]: {
      //width:'100%',
    },
  },
  topPartChart: {
    paddingLeft: '12px',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0 !important',
    },
  },
  mt64: {
    marginTop: '40px',
  },
  w100: {
    width:'100%',
  },
  boxChart: {
    display: 'flex',
    flexDirection: 'row',
    direction: 'rtl',

    border: '1px solid #dedede',
    padding: '16px',
    paddingTop: '64px',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  boxItemChart: {
    minHeight: '100px',
    width: '100%',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      alignItems: 'center',
    },
  },
  titleRowChart: {
    flex: '1',
    display: 'flex',
    padding: '16px',
    paddingLeft: '32px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      width: '100px',
    },
  },
  contentItemChart: {
    border: '1px solid #ccc',
    padding: '16px',
    borderLeft: 'none',
    width: '100%',
    flex: '8',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      marginRight: '78px',
      height: '100%',
    },
  },

  boxGuidChart: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    marginTop: '-32px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '16px',
    },
  },

  guidItemColor: {
    width: '100%',
    marginTop: '12px',

    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    fontSize: '11px',
  },

  guidCircleItem: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 8px',
  },

  titleChart: {
    position: 'absolute',
    left: '10px',
    top: '-12px',
    backgroundColor:  '#f4f3f3', //'#f6f9f9',
    padding: '5px 12px',
    borderRadius: '4px',
    cursor:'default',
  }

}));
